/* eslint-disable camelcase */
import React, { useState, useRef, useEffect, useMemo, forwardRef, useImperativeHandle } from "react";
import "./VisaForm.css";
import Cookies from "js-cookie";
import { Accordion, Col, Row, Form } from "react-bootstrap";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { SingleCalendar,TravelerSelector } from "../../../../components";
import SignatureCanvas from "react-signature-canvas";
import { ReactComponent as UploadIcon } from "../../../../assets/images/icons/solar_upload-line-duotone.svg";
import axios from "axios";
import debounce from "lodash.debounce";
import { useTranslation } from '../../../../contexts/TranslationContext';
import { axiosGet } from "../../../../utils/apis/api";


/* ─────────────────────────  Component  ───────────────────────── */
const VisaForm = forwardRef(({url, onChange = () => {}, showErrors = false, initialData = null,selectedDates,selectedDestination,onTravelersChange = () => {} }, ref) => {

  const [previewImage, setPreviewImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [travelers, setTravelers] = useState({
    adults: 1,
    children: 0,
    infants: 0,
    childrenAges: [],
  });

  useEffect(() => {
    onTravelersChange(travelers);
  }, [travelers]);


  const Lang = Cookies.get("preferred_language") || "en";
  const [activeAccordionKeys, setActiveAccordionKeys] = useState(['0']);
  const { t } = useTranslation();

  const staticVisaTypes = [
  { name: "Tourist Visa", location_name: t("TouristVisa") },
  { name: "Business Visa", location_name: t("BusinessVisa") },
  { name: "Student Visa", location_name:t( "StudentVisa") },
  { name: "Work Visa", location_name: t("WorkVisa") },
  { name: "Transit Visa", location_name: t("TransitVisa") },
];
  const fieldToAccordionMap = {
    // Personal Information
    full_name: '0',
    // date_of_birth: '0',
    // gender: '0',
    // nationality: '0',
    // passport_number: '0',
    // passport_issue: '0',
    // passport_expiry: '0',
    country_of_birth: '0',
    // marital_status: '0',
    phone: '0',
    email: '0',
    address: '0',
    
    // Travel Information
    // visa_type: '1',
    // purpose: '1',
    destination_country: '1',
    expected_travel: '1',
    expected_return: '1',
    // duration_stay: '1',
    // travelled_before: '1',
    
    // Employment & Financial
    // occupation: '2',
    // employer_name: '2',
    // employer_address:'2',
    // monthly_income: '2',
    
    // Accommodation
    // hotel_or_host: '3',
    
    // Declaration & Signature
    // agree_terms: '5',
    // signature: '5',
    
    // Files
    // file_bank: '2',
    file_passport: '4',
    // file_photo: '4',
    // file_finproof: '4',
    // file_flight: '4',
    // file_invitation: '4',
    // file_insurance: '4'
  };

  /* -------------------------------- state -------------------------------- */
  const [form, setForm] = useState({
    /* personal */
    full_name: "",
    //  date_of_birth: null, gender: "", nationality: "",
    // passport_number: "", passport_issue: null, passport_expiry: null,marital_status: "",
    country_of_birth: "", phone: "", email: "", address: "",
    /* travel */
    // visa_type: null, purpose: "",
   destination_country: null,expected_travel: null,expected_return: null,
    //   duration_stay: "",
    // travelled_before: "",
    /* work & finance */
    // occupation: "", employer_name: "", employer_address: "", monthly_income: "",

    /* accommodation */
    // hotel_or_host: "", contact_person_dest: "",
    /* uploads + declaration */
    files: {},
    //  agree_terms: false, signature: "",
  });

  const [errors, setErrors] = useState({});
  const inputRefs = useRef({});
  const sigPadRef = useRef();

  // Restore signature from initialData
  useEffect(() => {
    if (initialData?.signature && sigPadRef.current) {
      sigPadRef.current.fromDataURL(initialData.signature);
    }
  }, [initialData]);

  /* -------------------------------- lookup lists -------------------------------- */
  const [natQuery, setNatQuery] = useState("");
  const [natOptions, setNatOptions] = useState([]);
  const [natLoading, setNatLoading] = useState(false);

  const [destQuery, setDestQuery] = useState("");
  const [destOptions, setDestOptions] = useState([]);
  const [destLoading, setDestLoading] = useState(false);

  // const fetchNationalities = useMemo(
  //   () => debounce(async (q = "") => {
  //     try {
  //       setNatLoading(true);
  //       const params = q ? { search: q, limit: 20 } : { limit: 20 };
  //       const { data } = await axios.get(
  //         "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
  //         { params }
  //       );
  //       setNatOptions(data.result.countries || []);
  //     } catch (e) { console.error(e); }
  //     finally { setNatLoading(false); }
  //   }, 300),
  //   []
  // );

  const fetchNationalities = useMemo(
  () =>
    debounce(async (q = "") => {
      try {
        setNatLoading(true);
        const params = q ? { search: q, limit: 20 } : { limit: 20 };
        const json = await axiosGet(
          "https://crm.alltimestravels.com/api/method/alltimes.www.api.countries",
          params
        );

        setNatOptions(json?.result?.countries || []);
      } catch (error) {
        console.error("Error fetching nationalities:", error);
      } finally {
        setNatLoading(false);
      }
    }, 300),
  []
);

  // const fetchDestinations = useMemo(
  //   () => debounce(async (q = "") => {
  //     try {
  //       setDestLoading(true);
  //       const base = { location_type: "City", limit: 20 };
  //       const params = q.length >= 2 ? { ...base, search: q } : base;
  //       const { data } = await axios.get(
  //         "https://crm.alltimestravels.com/api/method/alltimes.www.api.locations",
  //         { params }
  //       );
  //       setDestOptions(data.result.locations || []);
  //     } catch (e) { console.error(e); }
  //     finally { setDestLoading(false); }
  //   }, 300),
  //   []
  // );

  const fetchDestinations = useMemo(
  () =>
    debounce(async (q = "") => {
      try {
        setDestLoading(true);
        const base = { location_type: "City", limit: 20 };
        const params = q.length >= 2 ? { ...base, search: q } : base;

        const json = await axiosGet(
          "https://crm.alltimestravels.com/api/method/alltimes.www.api.locations",
          params
        );
        setDestOptions(json?.result?.locations || []);
      } catch (error) {
        console.error("Error fetching destinations:", error);
      } finally {
        setDestLoading(false);
      }
    }, 300),
  []
);

  /* trigger fetching */
  useEffect(() => { fetchNationalities(natQuery); }, [natQuery, fetchNationalities]);
  useEffect(() => { if (destQuery.length >= 2) fetchDestinations(destQuery); }, [destQuery, fetchDestinations]);

  /* clean-up on unmount */
  useEffect(() => () => { fetchNationalities.cancel(); fetchDestinations.cancel(); }, [fetchNationalities, fetchDestinations]);

  /* -------------------------------- validation -------------------------------- */
  const required = {
    /* personal */
    full_name: t("FullNameIsRequired"),
    // date_of_birth: t("DateOfBirthIsRequired"),
    // gender: t("GenderIsRequired"),
    // nationality: t("NationalityIsRequired"),
    // passport_number: t("PassportNumberIsRequired"),
    // passport_issue: t("IssueDateIsRequired"),
    // passport_expiry: t("ExpiryDateIsRequired"),
    country_of_birth: t("CountryOfBrthIsRequired"),
    phone: t("PhoneNumberIsRequired"),
    email: t("EmailAddressIsRequired"),
    address: t("AddressIsRequired"),
    // marital_status: t("MaritalStatusIsRequired"),

    /* travel */
    // visa_type: t("VisaTypeIsRequired"),
    // purpose: t("PurposeOfTravelIsRequired"),
    destination_country: t("DestinationCountryIsRequired"),
    expected_travel: t("TravelDateIsRequired"),
    expected_return: t("ReturnDateIsRequired"),
    // duration_stay: t("DurationOfStayIsRequired"),
    // travelled_before:t("PleaseChooseAnOption"),

    /* work & finance */
    // occupation: t("OccupationIsRequired"),
    // employer_name: t("EmployerNameIsRequired"),
    // employer_address: t("EmployerAddressIsRequired"),
    // monthly_income: t("MonthlyIncomeIsRequired"),

    /* accommodation */
    // hotel_or_host: t("AccommodationDetailsAreRequired"),

    /* declaration */
    // agree_terms: t("YouMustAgreeToTheTerms"),
    // signature: t("SignatureIsRequired"),
  };

  const requiredFiles = {
    // bank: t("BankStatementIsRequired"),
    passport: t("PassportCopyIsRequired"),
    // photo: t("PhotographIsRequired"),
    // finproof: t("FinancialProofIsRequired"),
  };

  const rangeErr = {
    // travel: t("ReturnDateMustBeAfterTravelDate"),
    // passport: t("ExpiryDateMustBeAfterIssueDate"),
  };

  const validate = () => {
    const errs = {};

    /* mandatory scalar fields */
    Object.entries(required).forEach(([k, msg]) => {
      if (!form[k] || (typeof form[k] === "string" && !form[k].trim()))
        errs[k] = msg;
    });

    /* mandatory files */
    Object.entries(requiredFiles).forEach(([k, msg]) => {
      if (!form.files[k]) errs[`file_${k}`] = msg;
    });

      if (form.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(form.email)) {
          errs.email = t("EmailValidation");
        }
      }

      if (form.phone) {
        const phoneRegex = /^\+?[0-9]{6,15}$/;
        if (!phoneRegex.test(form.phone))
          errs.phone = t("InvalidPhoneNumberFormat");
      }

      // if (form.contact_person_dest) {
      //   const phoneRegex = /^\+?[0-9]{6,15}$/;
      //   if (!phoneRegex.test(form.contact_person_dest))
      //     errs.contact_person_dest = t("InvalidPhoneNumberFormat");
      // }

    /* date ranges */
    if (form.expected_travel && form.expected_return &&
      new Date(form.expected_travel) > new Date(form.expected_return))
      errs.expected_return = rangeErr.travel;

    // if (form.passport_issue && form.passport_expiry &&
    //   new Date(form.passport_issue) > new Date(form.passport_expiry))
    //   errs.passport_expiry = rangeErr.passport;

    setErrors(errs);
    return !Object.keys(errs).length;
  };

  /* notify parent on every form change */
  useEffect(() => { onChange(form, validate()); }, [form]); // eslint-disable-line react-hooks/exhaustive-deps

  /* -------------------------------- helpers -------------------------------- */
  const handleFileChange = (k, f) => {
    if (!f) return;
    setForm(p => ({ ...p, files: { ...p.files, [k]: f } }));
    if (inputRefs.current[k]) inputRefs.current[k].value = null;
  };
  
  const handleFileRemove = (k) => {
    setForm(p => { const files = { ...p.files }; delete files[k]; return { ...p, files }; });
    if (inputRefs.current[k]) inputRefs.current[k].value = null;
  };
  

  const err = (f) => showErrors && errors[f];
  const truncate = (n, max = 28) => (!n ? "" : n.length <= max ? n : `${n.slice(0, max - 6)}...${n.slice(-5)}`);
  const fileDisplayName = (f) => typeof f === "string" ? f.split("/").pop() : f.name;

  /* -------------------------------- initialData ↩︎→ form -------------------------------- */
  useEffect(() => {
    if (!initialData) return;
    const toDate = (s) => (s ? new Date(s) : null);

    setForm({
      ...initialData,
      // date_of_birth: toDate(initialData.date_of_birth),
      expected_travel: toDate(initialData.expected_travel),
      expected_return: toDate(initialData.expected_return),
      // passport_issue: toDate(initialData.passport_issue),
      // passport_expiry: toDate(initialData.passport_expiry),
    });

    onChange(initialData, true);
  }, [initialData]);

  const scrollToFirstError = () => {
    const firstErrorKey = Object.keys(errors)[0];
    if (firstErrorKey) {
      // Expand accordion section containing the error
      const accordionKey = fieldToAccordionMap[firstErrorKey];
      if (accordionKey && !activeAccordionKeys.includes(accordionKey)) {
        setActiveAccordionKeys(prev => [...prev, accordionKey]);
      }

      // Scroll to field after accordion expands
      setTimeout(() => {
        const element = document.getElementById(`field-${firstErrorKey}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 300); // Allow time for accordion to expand
    }
  };

  // Expose scroll method via ref
  useImperativeHandle(ref, () => ({
    scrollToFirstError
  }));

  // Auto-expand accordions when errors appear
  useEffect(() => {
    if (showErrors && Object.keys(errors).length > 0) {
      const errorAccordionKeys = Object.keys(errors)
        .map(field => fieldToAccordionMap[field])
        .filter(key => key !== undefined);

      setActiveAccordionKeys(prev => [
        ...prev,
        ...errorAccordionKeys.filter(key => !prev.includes(key))
      ]);
    }
  }, [showErrors, errors]);

    const truncateFilename = (name, maxLength = 30) => {
    if (!name || name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf(".");
    const ext = extIndex !== -1 ? name.slice(extIndex) : "";
    const base = name.slice(0, maxLength - ext.length - 3);
    return `${base}...${ext}`;
  };

  useEffect(() => {
  if (selectedDestination) {
    setForm((prev) => ({
      ...prev,
      destination_country: selectedDestination.name,
      destination_country_name: selectedDestination.location_name || "",
    }));
  }
}, [selectedDestination]);

  /* ======================= JSX ======================= */
  return (
    <Accordion
      className="hotel-form-accordion add-service-form-accordion services-visa-form-accordion-container"
      alwaysOpen
      activeKey={activeAccordionKeys}
      onSelect={(keys) => setActiveAccordionKeys(keys)}
    >
      {/* ---------------- 1. Personal ---------------- */}
      <Accordion.Item eventKey="0" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          1.{t("PersonalInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Full Name */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-full_name">
                <label className="hotel-form-input-label">
                  {t("FullName")} {t("AsPerPassport")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.full_name}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, full_name: e.target.value }))
                  }
                  placeholder={t("FullName")}
                />
                {err("full_name") && (
                  <div className="field-error">{errors.full_name}</div>
                )}
              </div>
            </Col>

            {/* Date of Birth */}
            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-date_of_birth"
              >
                <label className="hotel-form-input-label">
                  {t("DateOfBirth")}
                  <span>*</span>
                </label>
                <SingleCalendar
                  value={form.date_of_birth}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, date_of_birth: e.value }))
                  }
                  placeholder={t("DateOfBirth")}
                  showTime={false}
                />
                {err("date_of_birth") && (
                  <div className="field-error">{errors.date_of_birth}</div>
                )}
              </div>
            </Col> */}

            {/* Gender */}
            {/* <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-gender">
                <label className="hotel-form-input-label">
                  {t("Gender")} <span>*</span>
                </label>
                <Form.Select
                  size="sm"
                  value={form.gender}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, gender: e.target.value }))
                  }
                  className="hotel-form-input select-dropdown"
                >
                  <option value="" disabled hidden>
                    {t("SelectYourGender")}
                  </option>
                  <option value="male">{t("Male")}</option>
                  <option value="female">{t("Female")}</option>
                </Form.Select>
                {err("gender") && (
                  <div className="field-error">{errors.gender}</div>
                )}
              </div>
            </Col> */}

            {/* Nationality */}
            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-nationality"
              >
                <label className="hotel-form-input-label">
                  {t("Nationality")}
                  <span>*</span>
                </label>
                <Autocomplete
                  options={natOptions}
                  loading={natLoading}
                  getOptionLabel={(o) => o.name || ""}
                  value={
                    natOptions.find((o) => o.name === form.nationality) || null
                  }
                  onInputChange={(_, v) => setNatQuery(v)}
                  onChange={(_, v) =>
                    setForm((p) => ({ ...p, nationality: v?.name || "" }))
                  }
                  sx={{
                    ".MuiAutocomplete-inputRoot": {
                      fontSize: "12px",
                      flexDirection: Lang === "ar" ? "row-reverse" : "row",
                    },
                    ".MuiAutocomplete-endAdornment": {
                      left: Lang === "ar" ? "9 !important" : "unset !important",
                      right:
                        Lang === "ar" ? "unset !important" : "9 !important",
                    },
                    ".MuiInputBase-input": {
                      textAlign: Lang === "ar" ? "right" : "left",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      className="custom-dropdown-input"
                      {...params}
                      size="small"
                      placeholder={t("SelectNationality")}
                      InputProps={{
                        ...params.InputProps,
                        style: {
                          backgroundColor: "#FFF",
                          borderRadius: "6px",
                          padding: "9px 15px",
                        },
                        sx: {
                          backgroundColor: "#FFF",
                          borderRadius: "6px",
                          padding: "9px 15px !important",
                          fontFamily: '"Dmsans400"',
                          fontSize: "14px !important",
                          fontWeight: 400,
                          letterSpacing: "0.25px",
                        },
                      }}
                    />
                  )}
                />
                {err("nationality") && (
                  <div className="field-error">{errors.nationality}</div>
                )}
              </div>
            </Col> */}

            {/* Passport Number */}
            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_number"
              >
                <label className="hotel-form-input-label">
                  {t("PassportNumber")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.passport_number}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_number: e.target.value }))
                  }
                  placeholder= {t("PassportNumber")}
                />
                {err("passport_number") && (
                  <div className="field-error">{errors.passport_number}</div>
                )}
              </div>
            </Col> */}

            {/* Issue / Expiry */}
            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_issue"
              >
                <label className="hotel-form-input-label">
                  {t("PassportIssueDate")}
                  <span>*</span>
                </label>
                <SingleCalendar
                  value={form.passport_issue}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_issue: e.value }))
                  }
                  placeholder={t("IssueDate")}
                  showTime={false}
                />
                {err("passport_issue") && (
                  <div className="field-error">{errors.passport_issue}</div>
                )}
              </div>
            </Col> */}

            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-passport_expiry"
              >
                <label className="hotel-form-input-label">
                  {t("PassportExpiryDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.passport_expiry}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, passport_expiry: e.value }))
                  }
                  placeholder={t("ExpiryDate")}
                  showTime={false}
                />
                {err("passport_expiry") && (
                  <div className="field-error">{errors.passport_expiry}</div>
                )}
              </div>
            </Col> */}

            {/* Country of Birth */}
            <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-country_of_birth"
              >
                <label className="hotel-form-input-label">
                  {t("CountryOfBirth")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.country_of_birth}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, country_of_birth: e.target.value }))
                  }
                  placeholder= {t("CountryOfBirth")}
                />
                {err("country_of_birth") && (
                  <div className="field-error">{errors.country_of_birth}</div>
                )}
              </div>
            </Col>

            {/* Marital Status */}
            {/* <Col xl={4} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-marital_status"
              >
                <label className="hotel-form-input-label">
                  {t("MaritalStatus")}
                  <span>*</span>
                </label>
                <Form.Select
                  size="sm"
                  value={form.marital_status}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, marital_status: e.target.value }))
                  }
                  className="hotel-form-input select-dropdown"
                >
                  <option value="" disabled hidden>
                    {t("SelectMaritalStatus ")}
                  </option>
                  <option value="Single">{t("Single")}</option>
                  <option value="Married">{t("Married")}</option>
                  <option value="Divorced">{t("Divorced")}</option>
                  <option value="Widowed">{t("Widowed")}</option>
                  <option value="Separated">{t("Separated")}</option>
                </Form.Select>
                {err("marital_status") && (
                  <div className="field-error">{errors.marital_status}</div>
                )}
              </div>
            </Col> */}

            {/* Phone */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-phone">
                <label className="hotel-form-input-label">
                  {t("ContactNumber")} {t("Phone")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.phone}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, phone: e.target.value }))
                  }
                  placeholder={t("PhoneNumber")}
                />
                {err("phone") && (
                  <div className="field-error">{errors.phone}</div>
                )}
              </div>
            </Col>

            {/* Email */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-email">
                <label className="hotel-form-input-label">
                  {t("Email")} <span>*</span>
                </label>
                <input
                  type="email"
                  className="hotel-form-input"
                  value={form.email}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, email: e.target.value }))
                  }
                  placeholder={t("Email")}
                />
                {err("email") && (
                  <div className="field-error">{errors.email}</div>
                )}
              </div>
            </Col>

            {/* Address */}
            <Col xl={4} md={6}>
              <div className="hotel-form-input-container" id="field-address">
                <label className="hotel-form-input-label">
                  {t("ResidentialAddress")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.address}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, address: e.target.value }))
                  }
                  placeholder={t("ResidentialAddress")}
                />
                {err("address") && (
                  <div className="field-error">{errors.address}</div>
                )}
              </div>
            </Col>

            {/* Number of Passengers */}
            <Col xl={4} md={6} className="service-travelers">
              <div
                className="hotel-form-input-container"
                id="field-children_ages"
              >
                <label className="hotel-form-input-label">
                  {t("NumberOfPassengers")}
                </label>
                {/* <TravelerSelector
                  adults={form.number_of_passengers_adults}
                  children={form.number_of_passengers_children}
                  childrenAges={form.ages}
                  infants={infants}
                  onAdultsChange={(v) =>
                    setForm((p) => ({ ...p, number_of_passengers_adults: v }))
                  }
                  onChildrenChange={(v) =>
                    setForm((p) => ({
                      ...p,
                      number_of_passengers_children: v,
                    }))
                  }
                  onChildrenAgesChange={(v) =>
                    setForm((p) => ({ ...p, ages: v }))
                  }
                  onInfantsChange={setInfants}

                /> */}
                <TravelerSelector
                  adults={travelers.adults}
                  children={travelers.children}
                  childrenAges={travelers.childrenAges}
                  infants={travelers.infants}
                  onAdultsChange={(v) =>
                    setTravelers((p) => ({ ...p, adults: v }))
                  }
                  onChildrenChange={(v) =>
                    setTravelers((p) => ({ ...p, children: v }))
                  }
                  onChildrenAgesChange={(v) =>
                    setTravelers((p) => ({ ...p, childrenAges: v }))
                  }
                  onInfantsChange={(v) =>
                    setTravelers((p) => ({ ...p, infants: v }))
                  }
                />
                {err("children_ages") && (
                  <div className="field-error">{errors.children_ages}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* ---------------- 2. Travel ---------------- */}
      <Accordion.Item eventKey="1" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          2. {t("TravelInformation")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {/* Visa Type */}
            {/* <Col xl={4} md={4}>
              <div className="hotel-form-input-container" id="field-visa_type">
                <label className="hotel-form-input-label">
                  {t("TypeofVisa")}
                  <span>*</span>
                </label>
                <Autocomplete
                  options={staticVisaTypes}
                  getOptionLabel={(o) => o.location_name || ""}
                  value={
                    staticVisaTypes.find((o) => o.name === form.visa_type) ||
                    null
                  }
                  onChange={(_, v) =>
                    setForm((p) => ({ ...p, visa_type: v?.name || null }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectTypeVisa")}
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                        }}
                    />
                  )}
                />
                {err("visa_type") && (
                  <div className="field-error">{errors.visa_type}</div>
                )}
              </div>
            </Col> */}

            {/* Purpose */}
            {/* <Col xl={4} md={4}>
              <div className="hotel-form-input-container" id="field-purpose">
                <label className="hotel-form-input-label">
                  {t("PurposeofTravel")} <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.purpose}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, purpose: e.target.value }))
                  }
                  placeholder={t("PurposeofTravel")}
                />
                {err("purpose") && (
                  <div className="field-error">{errors.purpose}</div>
                )}
              </div>
            </Col> */}

            {/* Destination Country */}
            <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-destination_country"
              >
                <label className="hotel-form-input-label">
                  {t("DestinationCountry")} <span>*</span>
                </label>
                <Autocomplete
                  options={destOptions}
                  loading={destLoading}
                  getOptionLabel={(o) => {
                    const city = (o.location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    const parent = (o.parent_location_name || "")
                      .replace(/\s+/g, " ")
                      .trim();
                    return parent ? `${city} (${parent})` : city;
                  }}
                  value={
                    form.destination_country
                      ? {
                          name: form.destination_country,
                          location_name: form.destination_country_name || "",
                        }
                      : null
                  }
                  onOpen={() => {
                    if (!destOptions.length) fetchDestinations();
                  }}
                  onInputChange={(_, v, reason) => {
                    if (reason === "input") setDestQuery(v);
                  }}
                  onChange={(_, v) =>
                    setForm((p) => ({
                      ...p,
                      destination_country: v?.name || null,
                      destination_country_name: v?.location_name || "",
                    }))
                  }
                  sx={{
                      ".MuiAutocomplete-inputRoot": {
                        fontSize: "12px",
                        flexDirection: Lang === "ar" ? "row-reverse" : "row",
                      },
                      ".MuiAutocomplete-endAdornment": {
                        left:
                          Lang === "ar" ? "9 !important" : "unset !important",
                        right:
                          Lang === "ar" ? "unset !important" : "9 !important",
                      },
                      ".MuiInputBase-input": {
                        textAlign: Lang === "ar" ? "right" : "left",
                      },
                    }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder={t("SelectCountryOrCity")}
                      InputProps={{
                          ...params.InputProps,
                          style: {
                            direction: Lang === "ar" ? "rtl" : "ltr",
                          },
                          sx: {
                            backgroundColor: "#FFF",
                            borderRadius: "6px",
                            padding: "9px 15px !important",
                            fontFamily: '"Dmsans400"',
                            fontSize: "14px !important",
                            fontWeight: 400,
                            letterSpacing: "0.25px",
                          },
                      }}
                    />
                  )}
                />
                {err("destination_country") && (
                  <div className="field-error">
                    {errors.destination_country}
                  </div>
                )}
              </div>
            </Col>

            {/* Travel / Return */}
            <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-expected_travel"
              >
                <label className="hotel-form-input-label">
                  {t("ExpectedTravelDate")} <span>*</span>
                </label>
                <SingleCalendar
                  value={form.expected_travel}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, expected_travel: e.value }))
                  }
                  placeholder={t("ExpectedTravelDate")}
                  min={new Date(selectedDates.startDate)}
                  max={
                    form.expected_return
                      ? new Date(
                          Math.min(
                            new Date(form.expected_return).getTime(),
                            new Date(selectedDates.endDate).getTime()
                          )
                        )
                      : new Date(selectedDates.endDate)
                  }
                  viewDate={new Date(selectedDates.startDate)}
                />
                {err("expected_travel") && (
                  <div className="field-error">{errors.expected_travel}</div>
                )}
              </div>
            </Col>

            <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-expected_return"
              >
                <label className="hotel-form-input-label">
                  {t("ExpectedReturnDate")}
                  <span>*</span>
                </label>
                <SingleCalendar
                  value={form.expected_return}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, expected_return: e.value }))
                  }
                  placeholder= {t("ExpectedReturnDate")}
                  min={
                    form.expected_travel
                      ? new Date(
                          Math.max(
                            new Date(form.expected_travel).getTime(),
                            new Date(selectedDates.startDate).getTime()
                          )
                        )
                      : new Date(selectedDates.startDate)
                  }
                  max={new Date(selectedDates.endDate)}
                  viewDate={new Date(selectedDates.endDate)}
                />
                {err("expected_return") && (
                  <div className="field-error">{errors.expected_return}</div>
                )}
              </div>
            </Col>

            {/* Duration */}
            {/* <Col xl={4} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-duration_stay"
              >
                <label className="hotel-form-input-label">
                  {t("DurationOfStay")}
                  <span>*</span>
                </label>
                <input
                  type="number"
                  min={1}
                  step={1}
                  className="hotel-form-input"
                  value={form.duration_stay}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, duration_stay: e.target.value }))
                  }
                  onKeyDown={(e) => {
                    if (["-", "e", "E", "+", ",", "."].includes(e.key))
                      e.preventDefault();
                  }}
                  placeholder={t("DurationOfStay")}
                />
                {err("duration_stay") && (
                  <div className="field-error">{errors.duration_stay}</div>
                )}
              </div>
            </Col> */}

            {/* Traveled before */}
            {/* <Col xl={12}>
              <div
                className="add-service-form-checkbox-container"
                id="field-travelled_before"
              >
                <div className="add-service-form-checkbox-title">
                  {t("HaveYouTraveledCountryBefore")}
                  <span style={{ color: "red" }}> *</span>
                </div>
                <Form className="add-service-form-checkboxes">
                  {["1", "0"].map((opt) => (
                    <Form.Check
                      key={opt}
                      inline
                      type="radio"
                      label={opt === "1" ? t("Yes") : t("No")}
                      name="hasTravelledBefore"
                      value={opt}
                      checked={form.travelled_before === opt}
                      onChange={() =>
                        setForm((p) => ({ ...p, travelled_before: opt }))
                      }
                      className="add-service-form-checkbox"
                    />
                  ))}
                </Form>
                {err("travelled_before") && (
                  <div className="field-error">{errors.travelled_before}</div>
                )}
              </div>
            </Col> */}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* ---------------- 3. Employment & Financial ---------------- */}
      {/* <Accordion.Item eventKey="2" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          3. {t("EmploymentFinancialDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            Occupation
            <Col xl={3} md={4}>
              <div className="hotel-form-input-container" id="field-occupation">
                <label className="hotel-form-input-label">
                  {t("Occupation")} <span style={{ color: "red" }}>*</span>{" "}
                </label>
                <input
                  className="hotel-form-input"
                  value={form.occupation}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, occupation: e.target.value }))
                  }
                  placeholder={t("Occupation")}
                />
                {err("occupation") && (
                  <div className="field-error">{errors.occupation}</div>
                )}
              </div>
            </Col>

            Employer Name
            <Col xl={3} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-employer_name"
              >
                <label className="hotel-form-input-label">
                  {t("EmployerName")} <span style={{ color: "red" }}>*</span>{" "}
                </label>
                <input
                  className="hotel-form-input"
                  value={form.employer_name}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, employer_name: e.target.value }))
                  }
                  placeholder={t("EmployerName")}
                />
                {err("employer_name") && (
                  <div className="field-error">{errors.employer_name}</div>
                )}
              </div>
            </Col>

            Employer Address
            <Col xl={3} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-employer_address"
              >
                <label className="hotel-form-input-label">
                  {t("EmployerAddress")} <span style={{ color: "red" }}>*</span>{" "}
                </label>
                <input
                  className="hotel-form-input"
                  value={form.employer_address}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, employer_address: e.target.value }))
                  }
                  placeholder={t("EmployerAddress")}
                />
                 {err("employer_address") && (
                  <div className="field-error">{errors.employer_address}</div>
                )}
              </div>
            </Col>

            Monthly Income
            <Col xl={3} md={4}>
              <div
                className="hotel-form-input-container"
                id="field-monthly_income"
              >
                <label className="hotel-form-input-label">
                  {t("MonthlyIncome")} <span style={{ color: "red" }}>*</span>{" "}
                </label>
                <input
                  type="number"
                  min={0}
                  step="0.01"
                  className="hotel-form-input"
                  value={form.monthly_income}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      monthly_income:
                        e.target.value === "" ? "" : parseFloat(e.target.value),
                    }))
                  }
                  onKeyDown={(e) => {
                    if (["-", "e", "E", "+", ","].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder={t("MonthlyIncome")}
                />
                {err("monthly_income") && (
                  <div className="field-error">{errors.monthly_income}</div>
                )}
              </div>
            </Col>

            Bank Statement
            <Col xl={6} md={6}>
              <div className="hotel-form-input-container" id="field-file_bank">
                <label className="hotel-form-input-label">
                  {t("BankStatement")}
                  {t("ForFinancialProof")} <span>*</span>
                </label>
                <div className="custom-upload-wrapper">
                  <input
                    id="file-bank"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    style={{ display: "none" }}
                    ref={(el) => (inputRefs.current.bank = el)}
                    onChange={(e) =>
                      handleFileChange("bank", e.target.files[0])
                    }
                  />
                  <label htmlFor="file-bank" className="custom-upload-box">
                    {!form.files?.bank ? (
                      <>
                        <span className="upload-placeholder">
                          {t("Supported")}: JPEG, PNG, PDF
                        </span>
                        <UploadIcon className="upload-svg-icon" />
                      </>
                    ) : (
                      <>
                        <span className="upload-filename">
                          {truncateFilename(
                            typeof form.files.bank === "string"
                              ? form.files.bank.split("/").pop()
                              : form.files.bank.name
                          )}
                        </span>

                        <button
                          type="button"
                          className="file-action-btn view-file-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            const file = form.files.bank;
                            const isPdf =
                              (typeof file === "string" &&
                                file.toLowerCase().endsWith(".pdf")) ||
                              (file.name &&
                                file.name.toLowerCase().endsWith(".pdf"));
                            if (isPdf) {
                              window.open(
                                typeof file === "string"
                                  ? `${url}${file}`
                                  : URL.createObjectURL(file),
                                "_blank"
                              );
                            } else {
                              const previewUrl =
                                typeof file === "string"
                                  ? `${url}${file}`
                                  : URL.createObjectURL(file);
                              setPreviewImage(previewUrl);
                              setShowModal(true);
                            }
                          }}
                        >
                          {(() => {
                            const file = form.files.bank;
                            const isPdf =
                              (typeof file === "string" &&
                                file.toLowerCase().endsWith(".pdf")) ||
                              (file.name &&
                                file.name.toLowerCase().endsWith(".pdf"));
                            return isPdf ? t("View") : t("Preview");
                          })()}
                        </button>

                        <button
                          type="button"
                          className="file-action-btn remove-file-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleFileRemove("bank");
                          }}
                        >
                          Remove
                        </button>
                      </>
                    )}
                  </label>
                  {err("file_bank") && (
                    <div className="field-error">{errors.file_bank}</div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item> */}

      {/* ---------------- 4. Accommodation & Contacts ---------------- */}
      {/* <Accordion.Item eventKey="3" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          4. {t("AccommodationContactDetails")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            Hotel or Host
            <Col xl={6} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-hotel_or_host"
              >
                <label className="hotel-form-input-label">
                  {t("HotelBookingOrHostAddress")}
                  <span>*</span>
                </label>
                <input
                  className="hotel-form-input"
                  value={form.hotel_or_host}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, hotel_or_host: e.target.value }))
                  }
                  placeholder={t("HotelBookingOrHostAddress")}
                />
                {err("hotel_or_host") && (
                  <div className="field-error">{errors.hotel_or_host}</div>
                )}
              </div>
            </Col>

            Contact Person
            <Col xl={6} md={6}>
              <div
                className="hotel-form-input-container"
                id="field-contact_person_dest"
              >
                <label className="hotel-form-input-label">
                  {t("ContactPersonInDestinationCountryifApplicable")}
                </label>
                <input
                  className="hotel-form-input"
                  value={form.contact_person_dest}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      contact_person_dest: e.target.value,
                    }))
                  }
                  placeholder={t(
                    "ContactPersonInDestinationCountryifApplicable"
                  )}
                />
                {err("contact_person_dest") && (
                  <div className="field-error">
                    {errors.contact_person_dest}
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item> */}

      {/* ---------------- 5. Supporting Documents ---------------- */}
      <Accordion.Item eventKey="4" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          5.{t("SupportingDocuments")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            {[
              {
                key: "passport",
                label: t("PassportCopy"),
                mandatory: 1,
                id: "field-file_passport",
              },
              // {
              //   key: "photo",
              //   label: t("PassportSizedPhotograph"),
              //   mandatory: 1,
              //   id: "field-file_photo",
              // },
              // {
              //   key: "flight",
              //   label: t("FlightTicketIfBooked"),
              //   mandatory: 0,
              //   id: "field-file_flight",
              // },
              // {
              //   key: "invitation",
              //   label: t("InvitationLetterIfRequired"),
              //   mandatory: 0,
              //   id: "field-file_invitation",
              // },
              // {
              //   key: "finproof",
              //   label: t("ProofOfFinancialMeans"),
              //   mandatory: 1,
              //   id: "field-file_finproof",
              // },
              // {
              //   key: "insurance",
              //   label: t("TravelInsuranceIfRequired"),
              //   mandatory: 0,
              //   id: "field-file_insurance",
              // },
            ].map(({ key, label, mandatory, id }) => {
              const file = form.files[key];
              const isPdf =
                file?.name?.toLowerCase().endsWith(".pdf") ||
                (typeof file === "string" &&
                  file.toLowerCase().endsWith(".pdf"));
              return (
                <Col xl={6} md={6} key={key}>
                  <div
                    className="hotel-form-input-container"
                    id={`field-file_${key}`}
                  >
                    <label className="hotel-form-input-label">
                      {label} {mandatory ? <span>*</span> : null}
                    </label>
                    <div className="custom-upload-wrapper">
                      <input
                        id={`file-${key}`}
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png"
                        style={{ display: "none" }}
                        ref={(el) => (inputRefs.current[key] = el)}
                        onChange={(e) =>
                          handleFileChange(key, e.target.files[0])
                        }
                      />

                      {file ? (
                        <div className="custom-upload-box">
                          <div className="file-info">
                            {isPdf ? (
                              <a
                                href={
                                  typeof file === "string"
                                    ? `${url}${file}`
                                    : URL.createObjectURL(file)
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                className="file-link"
                              >
                                {truncate(fileDisplayName(file))}
                                <span className="file-type-badge">PDF</span>
                              </a>
                            ) : (
                              <span className="file-name">
                                {truncate(fileDisplayName(file))}
                              </span>
                            )}
                          </div>

                          <div className="file-actions">
                            <button
                              type="button"
                              className="file-action-btn view-file-btn"
                              onClick={() => {
                                if (isPdf) {
                                  window.open(
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file),
                                    "_blank"
                                  );
                                } else {
                                  const imageUrl =
                                    typeof file === "string"
                                      ? `${url}${file}`
                                      : URL.createObjectURL(file);
                                  setPreviewImage(imageUrl);
                                  setShowModal(true);
                                }
                              }}
                            >
                              {isPdf ? t("View") : t("Preview")}
                            </button>

                            <button
                              type="button"
                              className="file-action-btn remove-file-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileRemove(key);
                              }}
                            >
                              {t("Remove")}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <label
                          htmlFor={`file-${key}`}
                          className="custom-upload-box"
                        >
                          <span className="upload-placeholder">
                            {t("Supported")}: {t("Jpeg")}, {t("Png")},{" "}
                            {t("Pdf")}
                          </span>
                          <UploadIcon className="upload-svg-icon" />
                        </label>
                      )}
                    </div>
                    {err(`file_${key}`) && (
                      <div className="field-error" style={{ marginTop: 5 }}>
                        {errors[`file_${key}`]}
                      </div>
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        </Accordion.Body>
      </Accordion.Item>

      {/* ---------------- 6. Declaration & Sig ---------------- */}
      {/* <Accordion.Item eventKey="5" className="hotel-form-accordion-item">
        <Accordion.Header className="hotel-form-accordion-header">
          6. {t("DeclarationAndSignature")}
        </Accordion.Header>
        <Accordion.Body className="hotel-form-accordion-body">
          <Row>
            <Col xl={12}>
              <div
                className="hotel-form-input-container"
                id="field-agree_terms"
              >
                <Form.Check
                  type="checkbox"
                  label={t("IAgreeToTheTermsAndConditions")}
                  checked={form.agree_terms}
                  onChange={(e) =>
                    setForm((p) => ({ ...p, agree_terms: e.target.checked }))
                  }
                />
                {err("agree_terms") && (
                  <div className="field-error">{errors.agree_terms}</div>
                )}
              </div>
            </Col>

            Signature
            <Col xl={6}>
              <div className="hotel-form-input-container" id="field-signature">
                <label className="hotel-form-input-label">
                  {t("Signature")} <span>*</span>{" "}
                </label>
                <div
                  className="signature-container"
                  style={{ position: "relative" }}
                >
                  <SignatureCanvas
                    penColor="black"
                    canvasProps={{
                      width: 500,
                      height: 150,
                      className: "sigCanvas",
                    }}
                    ref={sigPadRef}
                    onEnd={() =>
                      setForm((p) => ({
                        ...p,
                        signature: sigPadRef.current.toDataURL(),
                      }))
                    }
                  />
                  <button
                    type="button"
                    onClick={() => {
                      sigPadRef.current.clear();
                      setForm((p) => ({ ...p, signature: "" }));
                    }}
                    title="Clear"
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 40,
                      background: "none",
                      border: "none",
                      fontSize: 18,
                    }}
                  >
                    ⟳
                  </button>
                </div>
                {err("signature") && (
                  <div className="field-error">{errors.signature}</div>
                )}
              </div>
            </Col>
          </Row>
        </Accordion.Body>
      </Accordion.Item> */}

      {previewImage && (
        <div
          className={`modal fade ${
            showModal ? "show d-block" : ""
          } service-files-modal`}
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
              ></button>
              <div className="service-image-file">
                <img
                  src={previewImage}
                  alt="preview"
                  style={{ maxWidth: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Accordion>
  );
});

export default VisaForm;